import { render, staticRenderFns } from "./ResourceEditor.vue?vue&type=template&id=361c718a&"
import script from "./ResourceEditor.vue?vue&type=script&lang=js&"
export * from "./ResourceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports